import { MatDialogRef } from '@angular/material/dialog';
import { defer, Observable, of } from 'rxjs';
import { filter, finalize, startWith, withLatestFrom } from 'rxjs/operators';

// Escape runs the dialog's own close/cancel method (so unsaved-changes prompts still work);
// it's ignored while saving, when Material already closes on Escape (disableClose false),
// and inside TinyMCE's own UI (its menus and dialogs, class "tox"), which handles Escape itself.
// keydownEvents completes when the dialog closes, so no unsubscribe is needed.
export function closeDialogOnEscape(
  dialogRef: MatDialogRef<unknown>,
  isSubmitting$: Observable<boolean> | null,
  close: () => void
): void {
  dialogRef.keydownEvents()
    .pipe(
      withLatestFrom((isSubmitting$ ?? of(false)).pipe(startWith(false))),
      filter(([event, isSubmitting]) => event.key === 'Escape'
        && !isSubmitting
        && dialogRef.disableClose
        && !(event.target instanceof Element && event.target.closest('.tox')))
    )
    .subscribe(() => close());
}

// for dialogs opened with disableClose false: Escape or a click outside can't close it while the request runs,
// then it's back to how it was opened
export function keepDialogOpen<T>(dialogRef: MatDialogRef<unknown>): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>): Observable<T> =>
    defer(() => {
      const disableClose = dialogRef.disableClose;
      dialogRef.disableClose = true;
      return source.pipe(finalize(() => { dialogRef.disableClose = disableClose; }));
    });
}
